<template>
    <div class="background-grid-white">
        <slot />
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.background-grid-white {
    width: 100%;
    height: 100%;
  background-size: 100% auto, cover;
  background: url('/images/promo/hero-section/background-white.svg'), url("/images/promo/hero-section/background-grid-white.svg") no-repeat, no-repeat top, top;
}
</style>
